import React, { useState } from 'react';
import { Modal, Button, Upload, Form, Input, Select, Typography, Space, Row, Col } from 'antd';
import { DownloadOutlined, InboxOutlined, DeleteFilled } from '@ant-design/icons';
import { showError, showSuccess } from '@components/notification';
import { URL_API } from '@configs/index';
import { downloadBlobFile, uploadBlobFile } from '@utils/utils';

const { Text } = Typography;
const { Option } = Select;

const ModalImportFavoriteFilter = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [loadingImport, setLoadingImport] = useState(false);

  const handleDownloadTemplate = async () => {
    try {
      setLoadingTemplate(true);
      await downloadBlobFile(
        `${URL_API}/api/favorite-filters/export-template`,
        'File mẫu import bộ lọc theo dõi.xlsx',
        null,
        'GET'
      );
    } catch (e) {
      showError('Có lỗi xảy ra khi tải file mẫu');
    } finally {
      setLoadingTemplate(false);
    }
  };

  const beforeUpload = (f) => {
    setFile(f);
    return false;
  };

  const handleRemoveFile = () => {
    setFile(null);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (!file) {
        showError('Bạn phải chọn file trước khi nhập!');
        return;
      }

      setLoadingImport(true);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('filter_name', values.filter_name.trim());
      formData.append('filter_description', values.filter_description || '');
      formData.append('filter_type', values.filter_type);

      await uploadBlobFile(
        `${URL_API}/api/favorite-filters/import`,
        'Kết quả import bộ lọc.xlsx',
        formData
      );

      showSuccess({ message: 'Import bộ lọc thành công!' });
      handleClose();
      if (onSuccess) onSuccess();
    } catch (e) {
      if (e?.errorFields) return; // validation error
      showError('Có lỗi xảy ra khi nhập dữ liệu');
    } finally {
      setLoadingImport(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    setFile(null);
    onCancel();
  };

  return (
    <Modal
      title="Import bộ lọc từ file Excel"
      open={visible}
      onCancel={handleClose}
      width={560}
      maskClosable={false}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loadingImport}
          onClick={handleSubmit}
          style={{ backgroundColor: '#0284c7', borderColor: '#0284c7' }}>
          Nhập dữ liệu
        </Button>
      ]}>
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        <Form.Item
          label="Tên bộ lọc"
          name="filter_name"
          rules={[{ required: true, message: 'Vui lòng nhập tên bộ lọc' }]}>
          <Input placeholder="Nhập tên bộ lọc" maxLength={255} />
        </Form.Item>

        <Form.Item label="Mô tả" name="filter_description">
          <Input.TextArea placeholder="Nhập mô tả (không bắt buộc)" rows={2} maxLength={500} />
        </Form.Item>

        <Form.Item
          label="Loại bộ lọc"
          name="filter_type"
          initialValue="customer"
          rules={[{ required: true, message: 'Vui lòng chọn loại bộ lọc' }]}>
          <Select>
            <Option value="customer">Khách hàng</Option>
            <Option value="device">Thiết bị</Option>
          </Select>
        </Form.Item>

        <Form.Item label="File Excel">
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Button
                loading={loadingTemplate}
                type="link"
                icon={<DownloadOutlined />}
                onClick={handleDownloadTemplate}
                style={{ color: '#0284c7', padding: 0 }}>
                Tải về file mẫu
              </Button>
            </Col>
            <Col span={24}>
              {!file ? (
                <Upload.Dragger
                  beforeUpload={beforeUpload}
                  showUploadList={false}
                  accept=".xlsx,.xls">
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Nhấn hoặc kéo thả file vào đây để tải lên</p>
                  <p className="ant-upload-hint">Chỉ hỗ trợ file Excel (.xlsx)</p>
                </Upload.Dragger>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    border: '1px solid #d9d9d9',
                    borderRadius: 8,
                    background: '#fafafa'
                  }}>
                  <Space>
                    <Text strong>{file.name}</Text>
                  </Space>
                  <Button type="text" danger icon={<DeleteFilled />} onClick={handleRemoveFile} />
                </div>
              )}
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalImportFavoriteFilter;
